export const clientDomain = 'https://smartvisuals-3dreviews.web.app/';
export const storageDomain = 'https://storage.yandexcloud.net/smartvisuals-3dreviews/';
export const functionUri = 'https://functions.yandexcloud.net/d4eepkkep93l8cct2khk';
